import { Link } from 'react-router-dom'
import './KleistEssay.css'

export default function KleistEssay() {
  return (
    <div className="kleist-essay">
      <div className="essay-content">
        <div className="essay-header">
          <h1>Über das Marionettentheater</h1>
          <p className="essay-subtitle">On the Marionette Theatre</p>
          <p className="essay-author">von Heinrich von Kleist</p>
          <p className="essay-date">1810</p>
        </div>

        <div className="essay-bilingual">
          <div className="essay-column german">
            <h2 className="column-title">Deutsch</h2>
            <div className="essay-text">
              <p>
                Als ich den Winter 1801 in M... zubrachte, traf ich daselbst eines Abends, 
                in einem öffentlichen Garten, den Herrn C... an, der seit kurzem, in dieser 
                Stadt, als erster Tänzer der Oper, angestellt war, und bei dem Publikum 
                außerordentliches Glück machte.
              </p>

              <p>
                Ich sagte ihm, daß ich erstaunt gewesen wäre, ihn schon mehrere Male in 
                einem Marionettentheater zu finden, das auf dem Markte zusammengezimmert 
                worden war, und den Pöbel, durch kleine dramatische Burlesken, mit Gesang 
                und Tanz durchwebt, belustigte.
              </p>

              <p>
                Er versicherte mir, daß ihm die Pantomimik dieser Puppen viel Vergnügen 
                machte, und ließ nicht undeutlich merken, daß ein Tänzer, der sich ausbilden 
                wolle, mancherlei von ihnen lernen könne.
              </p>

              <p>
                Da die Äußerung mir, durch die Art, wie er sie vorbrachte, mehr, als ein 
                bloßer Einfall schien, so ließ ich mich bei ihm nieder, um ihn über die 
                Gründe, auf die er eine so sonderbare Behauptung stützen könne, näher zu 
                vernehmen.
              </p>

              <p>
                Er fragte mich, ob ich nicht, in der Tat, einige Bewegungen der Puppen, 
                besonders der kleineren, im Tanz sehr graziös gefunden hätte.
              </p>

              <p>
                Diesen Umstand konnte ich nicht leugnen. Eine Gruppe von vier Bauern, die 
                nach einem raschen Takt die Ronde tanzte, hätte von Teniers nicht hübscher 
                gemalt werden können.
              </p>

              <p>
                Ich erkundigte mich nach dem Mechanismus dieser Figuren, und wie es möglich 
                wäre, die einzelnen Glieder derselben und ihre Punkte, ohne Myriaden von 
                Fäden an den Fingern zu haben, so zu regieren, als es der Rhythmus der 
                Bewegungen, oder der Tanz erfordere?
              </p>

              <p>
                Er antwortete, daß ich mir nicht vorstellen müsse, als ob jedes Glied einzeln, 
                während der verschiedenen Momente des Tanzes, von dem Maschinisten gestellt 
                und gezogen würde.
              </p>

              <p>
                Jede Bewegung, sagte er, hätte einen Schwerpunkt; es wäre genug, diesen, in 
                dem Innern der Figur, zu regieren; die Glieder, welche nichts als Pendel 
                wären, folgten, ohne irgend ein Zutun, auf eine mechanische Weise von selbst.
              </p>

              <p>
                Er setzte hinzu, daß diese Bewegung sehr einfach wäre; daß jedesmal, wenn der 
                Schwerpunkt in einer graden Linie bewegt wird, die Glieder schon Kurven 
                beschrieben; und daß oft, auf eine bloß zufällige Weise erschüttert, das 
                Ganze schon in eine Art von rhythmischer Bewegung käme, die dem Tanz ähnlich 
                wäre.
              </p>

              <p>
                Diese Bemerkung schien mir zuerst einiges Licht über das Vergnügen zu werfen, 
                das er in dem Theater der Marionetten zu finden vorgegeben hatte. Inzwischen 
                ahndete ich bei weitem die Folgerungen noch nicht, die er späterhin daraus 
                ziehen würde.
              </p>

              <p>
                Ich fragte ihn, ob er glaubte, daß der Maschinist, der diese Puppen regierte, 
                selbst ein Tänzer sein, oder wenigstens einen Begriff vom Schönen im Tanz 
                haben müsse?
              </p>

              <p>
                Er erwiderte, daß wenn ein Geschäft, von seiner mechanischen Seite, leicht sei, 
                daraus noch nicht folge, daß es ganz ohne Empfindung betrieben werden könne.
              </p>

              <p>
                Die Linie, die der Schwerpunkt zu beschreiben hat, wäre zwar sehr einfach, und, 
                wie er glaube, in den meisten Fällen, gerade. In Fällen, wo sie krumm sei, 
                scheine das Gesetz ihrer Krümmung wenigstens von der ersten oder höchstens 
                zweiten Ordnung; und auch in diesem letzten Fall nur elliptisch, welche Form 
                der Bewegung den Spitzen des menschlichen Körpers (wegen der Gelenke) überhaupt 
                die natürliche sei, und also dem Maschinisten keine große Kunst koste, zu 
                verzeichnen.
              </p>

              <p>
                Dagegen wäre diese Linie wieder, von einer anderen Seite, etwas sehr 
                Geheimnisvolles. Denn sie wäre nichts anders, als der Weg der Seele des 
                Tänzers, und er zweifle, daß sie anders gefunden werden könne, als dadurch, 
                daß sich der Maschinist in den Schwerpunkt der Marionette versetzt, d.h. mit 
                anderen Worten, tanzt.
              </p>

              <p>
                Ich erwiderte, daß man mir das Geschäft desselben als etwas ziemlich Geistloses 
                vorgestellt hätte: etwa was das Drehen einer Kurbel sei, die eine Leier spielt.
              </p>

              <p>
                Keineswegs, antwortete er. Vielmehr verhalten sich die Bewegungen seiner Finger 
                zur Bewegung der daran befestigten Puppen ziemlich künstlich, etwa wie Zahlen 
                zu ihren Logarithmen oder die Asymptote zur Hyperbel.
              </p>

              <p>
                Inzwischen glaube er, daß auch dieser letzte Bruch von Geist, von dem er 
                gesprochen, aus den Marionetten entfernt werden, daß ihr Tanz gänzlich ins 
                Reich mechanischer Kräfte hinübergespielt, und vermittelst einer Kurbel, so 
                wie ich es mir gedacht, hervorgebracht werden könne.
              </p>

              <p>
                Ich äußerte meine Verwunderung zu sehen, welcher Aufmerksamkeit er diese, für 
                den Haufen erfundene, Spielart einer schönen Kunst würdige. Nicht bloß, daß 
                er sie einer höheren Entwicklung für fähig halte: er scheine sich sogar selbst 
                damit zu beschäftigen.
              </p>

              <p>
                Er lächelte, und sagte, er getraue sich zu behaupten, daß wenn ihm ein 
                Mechanikus, nach den Forderungen, die er an ihn zu machen dächte, eine Marionette 
                bauen wollte, er vermittelst derselben einen Tanz darstellen würde, den weder 
                er, noch irgend ein anderer geschickter Tänzer seiner Zeit, Vestris selbst nicht 
                ausgenommen, zu erreichen imstande wäre.
              </p>

              <p>
                Haben Sie, fragte er, da ich den Blick schweigend zur Erde schlug: haben Sie 
                von jenen mechanischen Beinen gehört, welche englische Künstler für Unglückliche 
                verfertigen, die ihre Schenkel verloren haben?
              </p>

              <p>
                Ich sagte, nein: dergleichen wäre mir nie vor Augen gekommen.
              </p>

              <p>
                Es tut mir leid, erwiderte er; denn wenn ich Ihnen sage, daß diese Unglücklichen 
                damit tanzen, so fürchte ich fast, Sie werden es mir nicht glauben. - Was sag 
                ich, tanzen? Der Kreis ihrer Bewegungen ist zwar beschränkt; doch diejenigen, 
                die ihnen zu Gebote stehen, vollziehen sich mit einer Ruhe, Leichtigkeit und 
                Anmut, die jedes denkende Gemüt in Erstaunen setzen.
              </p>

              <p>
                Ich äußerte, scherzend, daß er ja, auf diese Weise, seinen Mann gefunden habe. 
                Denn derjenige Künstler, der einen so merkwürdigen Schenkel zu bauen imstande 
                sei, würde ihm unzweifelhaft auch eine ganze Marionette, seinen Forderungen 
                gemäß, zusammensetzen können.
              </p>

              <p>
                Wie, fragte ich, da er seinerseits ein wenig betreten zur Erde sah: wie sind 
                denn diese Forderungen, die Sie an die Kunstfertigkeit desselben zu machen 
                gedenken, bestellt?
              </p>

              <p>
                Nichts, antwortete er, was sich nicht auch schon hier fände; Ebenmaß, 
                Beweglichkeit, Leichtigkeit - nur alles in einem höheren Grade; und besonders 
                eine naturgemäßere Anordnung der Schwerpunkte.
              </p>

              <p>
                Und der Vorteil, den diese Puppe vor lebendigen Tänzern voraus haben würde?
              </p>

              <p>
                Der Vorteil? Vorzüglich dieser: daß sie sich niemals zierte. - Denn Ziererei 
                erscheint, wie Sie wissen, wenn die Seele (vis motrix) sich in irgend einem 
                anderen Punkte befindet, als in dem Schwerpunkt der Bewegung. Da der Maschinist, 
                vermittelst seines Drahtes oder Fadens, keinen anderen Punkt in seiner Gewalt 
                hat, als diesen, so sind alle übrigen Glieder, was sie sein sollen, tot, bloße 
                Pendel, und folgen dem Gesetze der Schwere; eine vortreffliche Eigenschaft, 
                die man vergebens bei dem größten Teil unserer Tänzer sucht.
              </p>

              <p>
                Sie sehen, daß diese Puppen nur Schwerpunkt haben, und daß, was die Ziererei 
                betrifft, sie gar nicht anders können, als immer anmutig sein. Aus diesem 
                Grunde sind sie unvergleichlich.
              </p>

              <p>
                Sehen Sie nur die P... an, fuhr er fort: wenn sie die Daphne spielt, und, 
                während sie Apoll verfolgt, sich nach ihm umsieht, so steht ihre Seele (vis 
                motrix) im Wirbel ihres Rückens; sie beugt sich, als ob sie brechen wollte, 
                und ein moderner Zuschauer, der, wie ich fürchte, in dem Ovid nichts als eine 
                fade Liebesgeschichte findet, würde Tränen vergießen. Sehen Sie dagegen die 
                B... an, wenn sie, nach vollendetem Tanz, in der Pose steht, in welcher sie 
                verweilt; diese Pose ist nicht mehr, als daß sie ihre Seele in den Ellenbogen 
                gesenkt hat; und weil sie müde ist, und nicht mehr denkt, so steht sie da, 
                wie ein Sack, mit hängenden Händen und eingeknicktem Nacken; und das ist das 
                Allerunschönste, was man sich vorstellen kann.
              </p>

              <p>
                Ich fragte ihn, ob er glaubte, daß der Maschinist selbst ein Künstler sein müsse, 
                oder ob es genüge, daß er ein Mechaniker sei?
              </p>

              <p>
                Er antwortete, daß wenn ein Geschäft, von seiner mechanischen Seite, leicht sei, 
                daraus noch nicht folge, daß es ganz ohne Empfindung betrieben werden könne.
              </p>

              <p>
                Die Linie, die der Schwerpunkt zu beschreiben hat, wäre zwar sehr einfach; doch 
                diese Linie wäre nichts anders, als der Weg der Seele des Tänzers; und er zweifle, 
                daß sie anders gefunden werden könne, als dadurch, daß sich der Maschinist in 
                den Schwerpunkt der Marionette versetzt, d.h. mit anderen Worten, tanzt.
              </p>

              <p>
                Mithin, sagte ich ein wenig zerstreut, müßten wir wieder von dem Baum der 
                Erkenntnis essen, um in den Stand der Unschuld zurückzufallen?
              </p>

              <p>
                Allerdings, antwortete er; das ist das letzte Kapitel von der Geschichte der 
                Welt.
              </p>
            </div>
          </div>

          <div className="essay-column english">
            <h2 className="column-title">English</h2>
            <div className="essay-text">
              <p>
                During the winter of 1801, I spent some time in M..., where I met one evening, 
                in a public garden, a certain Herr C..., who had recently been engaged as first 
                dancer at the opera house and had enjoyed extraordinary success with the public.
              </p>

              <p>
                I told him that I was astonished to have seen him several times at a marionette 
                theatre, which had been set up in the marketplace to entertain the common people 
                with dramatic burlesques interspersed with song and dance.
              </p>

              <p>
                He assured me that the pantomime of these puppets gave him much pleasure, and 
                he hinted quite clearly that a dancer who wished to perfect his art could learn 
                a great deal from them.
              </p>

              <p>
                Since this remark seemed to me to be more than a mere whim, I sat down beside 
                him to learn more about the reasons on which he based such a strange assertion.
              </p>

              <p>
                He asked me if I had not, in fact, found some of the dance movements of the 
                puppets, especially the smaller ones, very graceful.
              </p>

              <p>
                I could not deny this. A group of four peasants dancing a ronde in rapid time 
                could not have been painted more prettily by Teniers.
              </p>

              <p>
                I inquired about the mechanism of these figures and how it was possible to 
                control the individual limbs and their joints without having myriads of strings 
                attached to one's fingers, as the rhythm of the movements or the dance required.
              </p>

              <p>
                He replied that I must not imagine each limb being positioned and pulled by the 
                operator during the various moments of the dance.
              </p>

              <p>
                Every movement, he said, has a center of gravity; it is enough to control this 
                center of gravity from within the figure; the limbs, which are nothing but 
                pendulums, follow mechanically of their own accord, without any help.
              </p>

              <p>
                He added that this movement is very simple; whenever the center of gravity is 
                moved in a straight line, the limbs describe curves; and often, when shaken 
                merely by chance, the whole figure falls into a kind of rhythmic movement that 
                resembles dance.
              </p>

              <p>
                This observation seemed to me to shed some light at first on the pleasure he 
                claimed to find in the marionette theatre. But I was far from suspecting the 
                conclusions he would later draw from it.
              </p>

              <p>
                I asked him if he thought the operator who controls these puppets must himself 
                be a dancer, or at least have some idea of what is beautiful in dance.
              </p>

              <p>
                He replied that if a task is easy from a mechanical point of view, it does not 
                follow that it can be performed entirely without feeling.
              </p>

              <p>
                The line that the center of gravity must describe is, to be sure, very simple, 
                and in most cases, he believed, straight. When it is curved, the law of its 
                curvature seems to be at most of the first or second order; and even in the 
                latter case, only elliptical, which form of movement is natural to the human 
                body (because of the joints) and thus requires no great art from the operator 
                to trace.
              </p>

              <p>
                On the other hand, this line is something very mysterious. For it is nothing 
                other than the path of the dancer's soul, and he doubted that it could be found 
                unless the operator transposed himself into the center of gravity of the 
                marionette—in other words, unless he danced.
              </p>

              <p>
                I replied that I had been told his work was rather spiritless, like turning a 
                crank on a barrel organ.
              </p>

              <p>
                Not at all, he answered. On the contrary, the movements of his fingers are 
                related to the movements of the attached puppets in a rather artistic way, 
                like numbers to their logarithms or the asymptote to the hyperbola.
              </p>

              <p>
                However, he believed that even this last trace of spirit could be removed from 
                the marionettes, that their dance could be transferred entirely into the realm 
                of mechanical forces and produced by turning a crank, as I had imagined.
              </p>

              <p>
                I expressed my surprise at seeing him pay such attention to this species of 
                plaything invented for the amusement of the mob. Not only did he seem to think 
                it capable of higher development, but he appeared to be working on it himself.
              </p>

              <p>
                He smiled and said that he dared to claim that if a mechanician could build him 
                a marionette according to the requirements he would specify, he could perform 
                a dance with it that neither he nor any other skilled dancer of his time, not 
                even Vestris himself, would be able to match.
              </p>

              <p>
                Have you, he asked, as I looked silently at the ground—have you heard of those 
                mechanical legs that English artists have constructed for unfortunate people who 
                have lost their limbs?
              </p>

              <p>
                I said no, I had never seen anything of the kind.
              </p>

              <p>
                I'm sorry, he replied, for when I tell you that these unfortunates can dance 
                with them, I'm almost afraid you won't believe me. What am I saying—dance? The 
                range of their movements is limited, to be sure, but the movements they can 
                perform are executed with a calm, ease, and grace that every thinking person 
                would find astonishing.
              </p>

              <p>
                I said jokingly that he had found his man. For the artist who could build such 
                a remarkable leg would undoubtedly be able to construct a whole marionette 
                according to his requirements.
              </p>

              <p>
                What, I asked, as he looked somewhat embarrassed at the ground—what are these 
                requirements you would make of the artist's skill?
              </p>

              <p>
                Nothing, he answered, that is not already found here: proportion, flexibility, 
                lightness—but all in a higher degree; and especially a more natural arrangement 
                of the centers of gravity.
              </p>

              <p>
                And what advantage would this puppet have over living dancers?
              </p>

              <p>
                Advantage? Above all this: that it would never be affected. For affectation 
                appears, as you know, when the soul (vis motrix) is located at any point other 
                than the center of gravity of the movement. Since the operator, by means of 
                his wire or thread, can control no other point in his puppet than this one, all 
                the other limbs are, as they should be, dead, mere pendulums, and follow the 
                law of gravity—an excellent quality that one looks for in vain in most of our 
                dancers.
              </p>

              <p>
                You see that these puppets have only gravity, and as far as affectation is 
                concerned, they cannot help but be graceful. For this reason they are 
                incomparable.
              </p>

              <p>
                Look at P..., he continued: when she plays Daphne and, pursued by Apollo, looks 
                back at him, her soul (vis motrix) is located in the small of her back; she 
                bends as if she would break, and a modern spectator, who, I fear, finds in Ovid 
                only a tedious love story, would shed tears. Look, on the other hand, at B..., 
                when she stands in the pose in which she remains after completing her dance; 
                this pose is nothing more than that she has sunk her soul into her elbow; and 
                because she is tired and no longer thinks, she stands there like a sack, with 
                drooping hands and bent neck; and that is the ugliest thing one can imagine.
              </p>

              <p>
                I asked him if he thought the operator himself must be an artist, or whether it 
                would be enough for him to be a mechanician.
              </p>

              <p>
                He replied that if a task is easy from a mechanical point of view, it does not 
                follow that it can be performed entirely without feeling.
              </p>

              <p>
                The line that the center of gravity must describe is, to be sure, very simple; 
                but this line is nothing other than the path of the dancer's soul; and he 
                doubted that it could be found unless the operator transposed himself into the 
                center of gravity of the marionette—in other words, unless he danced.
              </p>

              <p>
                Therefore, I said, somewhat distractedly, we would have to eat of the tree of 
                knowledge again in order to return to the state of innocence?
              </p>

              <p>
                Certainly, he answered; that is the last chapter in the history of the world.
              </p>
            </div>
          </div>
        </div>

        <div className="essay-navigation">
          <Link to="/" className="nav-link">← Zurück zur Startseite</Link>
          <Link to="/sim" className="nav-link">Zur Simulation →</Link>
        </div>

        <div className="essay-source">
          <p>
            German text from{' '}
            <a href="https://annotext.dartmouth.edu/texts/10004" target="_blank" rel="noopener noreferrer">
              Dartmouth Annotext
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
